import { Link, useLocation } from "react-router-dom";
import img from "../../assets/contral.png";
import "react-datepicker/dist/react-datepicker.css";
import "./courses.css";
import { useTranslation } from "react-i18next";

const ContractualCoursesForm = () => {
  const location = useLocation();
  const { t } = useTranslation();
  return (
    <div className="centeral-form-new no-print">
      {location.pathname !== "/login" &&
        location.pathname !== "/forget" &&
        location.pathname !== "/otp-code" && (
          <Link to="/contractural" className="centeral-btn" >
            <img src={img} alt="" className="ms-2" /> {t('routes.contractural')}
          </Link>
        )}
    </div>
  );
};

export default ContractualCoursesForm;